import { SVGProps } from 'react'

export function BubbleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.5625 18.75C8.54688 17.3438 8 15.625 8 13.75C8 9.88281 10.5 6.60156 13.9766 5.46875C12.6875 4.41406 11.0469 3.75 9.25 3.75C5.10938 3.75 1.75 7.10938 1.75 11.25C1.75 15.3906 5.10938 18.75 9.25 18.75C9.32812 18.75 9.44531 18.75 9.5625 18.75ZM10.9688 18.5547C14.2891 17.7734 16.75 14.8047 16.75 11.25C16.75 9.45312 16.0859 7.77344 14.9922 6.48438C11.7109 7.26562 9.25 10.2344 9.25 13.75C9.25 15.5859 9.875 17.2656 10.9688 18.5547ZM10.5 19.9219C10.1094 20 9.67969 20 9.25 20C4.40625 20 0.5 16.0938 0.5 11.25C0.5 6.44531 4.40625 2.5 9.25 2.5C11.6719 2.5 13.8594 3.51562 15.4609 5.11719C15.8516 5.03906 16.2812 5 16.75 5C21.5547 5 25.5 8.94531 25.5 13.75C25.5 18.5938 21.5547 22.5 16.75 22.5C14.2891 22.5 12.1016 21.5234 10.5 19.9219ZM16.4375 6.28906C17.4141 7.69531 18 9.41406 18 11.25C18 15.1562 15.4609 18.4375 11.9844 19.5703C13.2734 20.625 14.9141 21.25 16.75 21.25C20.8906 21.25 24.25 17.8906 24.25 13.75C24.25 9.60938 20.8906 6.25 16.75 6.25C16.6328 6.25 16.5156 6.28906 16.4375 6.28906Z" />
    </svg>
  )
}
